export const defaultFontFamilies = {
	base: 'Roboto, sans-serif',
	header: 'Poppins, sans-serif',
	code: 'Roboto Mono, monospace',
}
